<div fxLayout class="metrics-page">
  <main class="p-0" fxFlex [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <ng-container [ngSwitch]="pageLoadingState$ | async">
      <ng-container *ngSwitchCase="LoadingState.Pending">
        <div class="m-auto">
          <div class="flex h-full">
            <hospitable-loading></hospitable-loading>
          </div>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="LoadingState.Success">
        <ng-container *ngIf="user">
          <div class="currencies-mobile-select">
            <div class="flex flex-row w-full flex-row-reverse">
              <ul class="flex list-none">
                <ng-container *ngIf="currencies$ | async as currencies">
                  <li class="flex flex-row-reverse ml-auto min-w-fit" *ngIf="currencies.length > 1">
                    <mat-form-field class="input__mini mb-0 -mb-4 -bottom-2 w-24">
                      <mat-label>Currency</mat-label>
                      <mat-select
                        [value]="defaultCurrency$ | async"
                        placeholder="Select a currency"
                        (selectionChange)="changeDefaultCurrency($event)">
                        <mat-option *ngFor="let option of currencies" [value]="option.currency">
                          {{ option.currency }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-container *ngIf="conversionRates$ | async as conversionRates">
                      <ng-container *ngIf="conversionRates && conversionRates.length > 0">
                        <div
                          class="grass-darker clickable text-xs text-green-dark mt-3.5 mr-4"
                          [satPopoverAnchor]="p"
                          (mouseenter)="p.open()"
                          (mouseleave)="p.close()">
                          <sbnb-icon [size]="14" class="text-grass-darker mr-1" icon="alert-triangle"></sbnb-icon>

                          Conversion rates applied
                        </div>

                        <sat-popover verticalAlign="below" horizontalAlign="start" #p>
                          <div class="popover">
                            <div *ngFor="let rate of conversionRates">
                              <strong style="vertical-align: top">
                                {{ rate.base_currency }} to {{ rate.to_currency }}
                              </strong>
                              <div style="display: inline-block">
                                <p>
                                  {{ rate.rate }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </sat-popover>
                      </ng-container>
                    </ng-container>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>

          <div class="flex flex-row w-full">
            <div class="flex flex-col flex-grow p-1 sbnbDesktop:p-6">
              <div class="text-md font-light text-center border-b border-alt-gray">
                <ul class="flex h-14 overflow-y-hidden -mb-px list-none overflow-x-auto">
                  <li class="min-w-fit" *ngFor="let tab of tabs">
                    <a
                      (click)="changeTab(tab)"
                      class="inline-block p-4 h-14 border-b-2 border-transparent cursor-pointer"
                      [ngClass]="{
                        'font-light opacity-100  border-b-2 border-pink-dark': tab === activeTab,
                        'opacity-70': tab !== activeTab
                      }">
                      {{ tab }}
                    </a>
                  </li>

                  <ng-container *ngIf="currencies$ | async as currencies">
                    <li
                      class="currencies-desktop-select flex flex-row-reverse ml-auto min-w-fit"
                      *ngIf="currencies.length > 1">
                      <mat-form-field class="input__mini mb-0 -mb-4 -bottom-2 w-24">
                        <mat-label>Currency</mat-label>
                        <mat-select
                          [value]="defaultCurrency$ | async"
                          placeholder="Select a currency"
                          (selectionChange)="changeDefaultCurrency($event)">
                          <mat-option *ngFor="let option of currencies" [value]="option.currency">
                            {{ option.currency }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <ng-container *ngIf="conversionRates$ | async as conversionRates">
                        <ng-container *ngIf="conversionRates && conversionRates.length > 0">
                          <div
                            class="grass-darker clickable text-xs text-green-dark mt-3.5 mr-4"
                            [satPopoverAnchor]="p"
                            (mouseenter)="p.open()"
                            (mouseleave)="p.close()">
                            <sbnb-icon [size]="14" class="text-grass-darker mr-1" icon="alert-triangle"></sbnb-icon>

                            <span>Conversion rates applied</span>
                          </div>

                          <sat-popover verticalAlign="below" horizontalAlign="start" #p>
                            <div class="popover">
                              <div *ngFor="let rate of conversionRates">
                                <strong style="vertical-align: top">
                                  {{ rate.base_currency }}
                                  to
                                  {{ rate.to_currency }}
                                </strong>
                                <div style="display: inline-block">
                                  <p>
                                    {{ rate.rate }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </sat-popover>
                        </ng-container>
                      </ng-container>
                    </li>
                  </ng-container>
                </ul>
              </div>

              <div class="flex flex-row w-full">
                <div class="flex flex-col flex-grow w-full mt-8" *ngIf="activeTab">
                  <ng-container [ngSwitch]="activeTab">
                    <ng-container *ngSwitchCase="Metrics.Reservations">
                      <hospitable-metrics-reservations [user]="user"></hospitable-metrics-reservations>
                    </ng-container>
                    <ng-container *ngSwitchCase="Metrics.Taxes">
                      <hospitable-metrics-taxes [user]="user"></hospitable-metrics-taxes>
                    </ng-container>
                    <ng-container *ngSwitchCase="Metrics.Reviews">
                      <hospitable-metrics-reviews [user]="user"></hospitable-metrics-reviews>
                    </ng-container>
                    <ng-container *ngSwitchCase="Metrics.Tasks">
                      <hospitable-metrics-tasks [user]="user"></hospitable-metrics-tasks>
                    </ng-container>
                    <ng-container *ngSwitchCase="Metrics.EarlierExports">
                      <hospitable-metrics-exports [user]="user"></hospitable-metrics-exports>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="LoadingState.Error">
        <div class="m-auto">
          <div class="flex h-full">
            <hospitable-page-level-error></hospitable-page-level-error>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </main>
</div>
